<template>
    <div
        :class="{ 'adjust-item-task-highlight': task._highlight }"
        class="adjust-item-task"
    >
        <span
            :style="{ color: color, border: `1px solid ${color}` }"
            class="task-index"
            >{{ index + 1 }}</span
        >
        <span
            v-if="task.children && task.children.length"
            :title="`菜鸟大件，共(task.children.length)个运单`"
            class="task-tag"
        >
            菜<span class="task-tag-value">{{ task.children.length }}</span>
        </span>
        <span
            :title="task.customerOrderNo"
            class="task-no"
            @dblclick.stop.prevent="
                handleDoubleClickToCopy(task.customerOrderNo)
            "
            >{{ task.customerOrderNo }}</span
        >
        <span
            :title="task.receiverName"
            class="task-cubic"
            @dblclick.stop.prevent="handleDoubleClickToCopy(task.receiverName)"
            >{{ task.receiverName }}</span
        >
        <span
            :title="task.receiverMobile"
            class="task-no"
            @dblclick.stop.prevent="
                handleDoubleClickToCopy(task.receiverMobile)
            "
            >{{ task.receiverMobile }}</span
        >
        <span
            :title="Math.round(task.totalVolume * 100) / 100"
            class="task-cubic"
            @dblclick.stop.prevent="handleDoubleClickToCopy(totalVolume)"
            >{{ totalVolume }} m³</span
        >
        <span
            :title="task.receiverDetailAddr"
            class="task-address"
            @dblclick.stop.prevent="
                handleDoubleClickToCopy(task.receiverDetailAddr)
            "
            >{{ task.receiverDetailAddr }}</span
        >
        <div class="task-actions" v-if="adjustCheckDisable">
            <el-button
                v-has="'otp02020004'"
                :disabled="disabled"
                type="text"
                @click="handleDelete"
                >删除</el-button
            >
            <el-button
                v-has="'otp02020005'"
                :disabled="disabled"
                type="text"
                @click="handleAdd"
                >添加</el-button
            >
        </div>
    </div>
</template>

<script>

import { copyText } from '../utils/message';

export default {
    name: 'train-adjust-task',
    props: {
        disabled: Boolean,
        adjustCheckDisable: Boolean,
        index: Number,
        task: {
            type: Object
        },
        color: String
    },
    computed: {
        totalVolume () {
            if (this.task.children && this.task.children.length) {
                /// 菜鸟大件，计算同一客户订单号下的体积之和
                return this.task.children.reduce((_acc, _task) => _acc + _task.totalVolume, 0);
            } else {
                return Math.round(this.task.totalVolume * 100) / 100;
            }
        }
    },
    methods: {
        handleDelete (e) {
            e.stopPropagation();
            return this.$confirm('请确认是否删除该运单？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$emit('on-delete', this.index, this.task);
                })
                .catch((e) => { });
        },
        handleAdd (e) {
            e.stopPropagation();
            this.$emit('on-add', this.index, this.task);
        },
        handleDoubleClickToCopy (text) {
            copyText(this.$message, String(text));
        }
    }
};
</script>

<style lang="less" scoped>
.adjust-item-task {
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-size: 13px;

    &.adjust-item-task-highlight {
        background-color: #cccccc88;
    }

    & > * {
        display: inline-block;
        margin-left: 10px;
        color: #555757;

        &:first-child {
            margin-left: 0;
        }
    }

    .task-index {
        min-width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        border-radius: 50%;
        font-size: 12px;
        background-color: white;
    }

    .task-tag {
        display: flex;
        background-color: salmon;
        border-radius: 4px;
        padding: 0 2px;
        color: white;

        .task-tag-value {
            font-size: 0.8rem;
        }
    }

    .task-no {
        min-width: 80px;
        max-width: 260px;
    }

    .task-address {
        //max-width: 450px;
        flex-grow: 1;
    }

    .task-cubic {
        min-width: 40px;
        max-width: 140px;
    }

    .task-no,
    .task-cubic,
    .task-address {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        user-select: none;
    }

    .task-actions {
        margin-top: 0.19rem;
        min-width: 70px;
        text-align: right;
    }
}
</style>
